<app-card [type]="3" [title]="'feature.song.upload_song' | translate">
  <app-song-edit-card
    cardBody3
    [songUploadData]="songUploadData"
    [song]="songUploadData.song"
    (submitEvent)="onUpload()"
    (uploadSuccessEvent)="onUploadSuccess($event)"
  ></app-song-edit-card>
</app-card>
